import React from "react";
import { useIntl } from "react-intl";
import { MemoizedChip } from "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/progress/CircularProgress.js";
import { CircularProgressWithLabel } from "../../../components/progress/CircularProgressWithLabel.js";
import { BulkStatusTypeName } from "../constants.js";
import { BulkStatus } from "../types.js";
const BulkExecutionStepTotalProgress = ({
  totalItems,
  processedItems,
  failedItems,
  affectedEntityName,
  children
}) => {
  const progress = totalItems && processedItems ? processedItems / totalItems * 100 : 0;
  const bulkStatus = failedItems > 0 ? BulkStatus.Warning : BulkStatus.Success;
  const { formatMessage } = useIntl();
  return !totalItems || processedItems !== totalItems ? /* @__PURE__ */ React.createElement(
    CircularProgressWithLabel,
    {
      "data-testid": "bulkExecutionSummaryStepCircularProgress",
      value: progress,
      totalItemCount: totalItems,
      processedItemLabel: formatMessage(affectedEntityName)
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MemoizedChip, { value: bulkStatus, chipName: BulkStatusTypeName }), children);
};
export {
  BulkExecutionStepTotalProgress
};
//# sourceMappingURL=BulkExecutionStepTotalProgress.js.map
